import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { UiWhatsappFabComponent } from '@system-dyg/shared/ui';
import { isMobileViewport, viewportMatches } from '@system-dyg/shared/utils';

const PORTAL_CLIENTES_WHATSAPP_HREF =
  'https://wa.me/523347151793?text=' +
  encodeURIComponent(
    'Hola. soy cliente de Diseño y Gestión y necesito soporte se pueden comunicar a este numero por favor. Gracias',
  );

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, UiWhatsappFabComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly router = inject(Router);
  private readonly isNarrowViewport = isMobileViewport();
  private readonly isShortViewport = viewportMatches(
    '(max-height: 540px) and (orientation: landscape)',
  );

  protected readonly whatsappSupportHref = PORTAL_CLIENTES_WHATSAPP_HREF;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  protected readonly liftWhatsappFab = computed(() => {
    const path = this.currentUrl().split('?')[0] ?? '/';
    const isLogin =
      path === '/' ||
      path === '' ||
      path === '/personalize-password' ||
      path === '/recover-password';
    const compactChrome = this.isNarrowViewport() || this.isShortViewport();
    return !isLogin && compactChrome;
  });
}
